'use strict';
module.exports = require('../../full/object/get-own-property-descriptor');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/object/get-own-property-descriptor.js
// module id = 606
// module chunks = 13